<div class="flex min-h-screen items-center justify-center bg-neutral-50 dark:bg-neutral-950">
	<div class="w-full max-w-md px-4">

		<div class="rounded-lg border border-neutral-200 bg-white p-8 shadow-sm dark:border-neutral-800 dark:bg-neutral-900">

			<h1 class="mb-1 text-xl font-semibold text-neutral-900 dark:text-neutral-100">
				<span ro-i18n eikey="login.firstLogin.title">Welcome — Set Your Password</span>
			</h1>
			<p class="mb-6 text-sm text-neutral-500 dark:text-neutral-400">
				<span ro-i18n eikey="login.firstLogin.instruction">Choose a strong password to activate your account.</span>
			</p>

			<alerts [namespace]="'1stlg'"></alerts>

			<form [formGroup]="passwordForm" novalidate (ngSubmit)="onSubmit()">

				<div class="mb-4">
					<label class="mb-1 block text-sm font-medium text-neutral-700 dark:text-neutral-300">
						<span ro-i18n eikey="dashboard.password.labels.password">New Password</span>
					</label>
					<input
						id="password"
						type="password"
						formControlName="password"
						class="w-full rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm text-neutral-900 placeholder-neutral-400 focus:border-neutral-500 focus:outline-none dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100"
						[class.border-red-500]="submitted && formControls['password'].errors"
						placeholder="{{ placeholders.password }}"
					/>
					@if (submitted && formControls['password'].errors?.['required']) {
						<p class="mt-1 text-xs text-red-600 dark:text-red-400">
							<span ro-i18n eikey="dashboard.password.errorMsgs.passwordReq">Password is required</span>
						</p>
					}
					@if (submitted && formControls['password'].errors?.['pattern']) {
						<p class="mt-1 text-xs text-red-600 dark:text-red-400">
							<span ro-i18n eikey="dashboard.password.errorMsgs.invalidPassword">Password must be 8–16 characters and include uppercase, lowercase, number, and symbol</span>
						</p>
					}
				</div>

				<div class="mb-6">
					<label class="mb-1 block text-sm font-medium text-neutral-700 dark:text-neutral-300">
						<span ro-i18n eikey="dashboard.password.labels.confirm">Confirm Password</span>
					</label>
					<input
						id="confirmPassword"
						type="password"
						formControlName="confirmPassword"
						class="w-full rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm text-neutral-900 placeholder-neutral-400 focus:border-neutral-500 focus:outline-none dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100"
						[class.border-red-500]="submitted && passwordForm.errors"
						placeholder="{{ placeholders.confirm }}"
					/>
					@if (submitted && formControls['confirmPassword'].errors?.['required']) {
						<p class="mt-1 text-xs text-red-600 dark:text-red-400">
							<span ro-i18n eikey="dashboard.password.errorMsgs.passwordReq">Confirm password is required</span>
						</p>
					}
					@if (submitted && passwordForm.errors?.['passwordMismatch']) {
						<p class="mt-1 text-xs text-red-600 dark:text-red-400">
							<span ro-i18n eikey="dashboard.password.errorMsgs.passwordMismatch">Passwords do not match</span>
						</p>
					}
				</div>

				<div class="flex gap-3">
					<button
						type="submit"
						[disabled]="!passwordForm.valid || submitting()"
						class="flex-1 rounded-md bg-neutral-900 py-2 text-sm font-medium text-white hover:bg-neutral-700 disabled:opacity-50 dark:bg-neutral-100 dark:text-neutral-900 dark:hover:bg-neutral-300"
					>
						@if (submitting()) {
							<span ro-i18n eikey="general.saving">Saving…</span>
						} @else {
							<span ro-i18n eikey="general.save">Save Password</span>
						}
					</button>
					<button
						type="button"
						(click)="onCancel()"
						class="rounded-md border border-neutral-300 px-4 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-50 dark:border-neutral-700 dark:text-neutral-300 dark:hover:bg-neutral-800"
					>
						<span ro-i18n eikey="general.cancel">Cancel</span>
					</button>
				</div>

			</form>
		</div>
	</div>
</div>
